<template>
  <div class="w-full mb-4 md:mb-2">
    <label
      :for="id"
      class="inline-block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 cursor-pointer"
      >{{ label }}</label
    >
    <template v-if="!Array.isArray(modelValue)">
      <input
        :id="id"
        type="text"
        class="block w-full bg-white rounded p-1 focus:bg-white border focus:border-gray-600 valid:border-green-400 appearance-none focus:outline-none"
        :value="modelValue"
        @change="(e) => $emit('update:modelValue', e)"
        :disabled="disabled"
        :required="required"
      />
    </template>
    <template v-else>
      <div class="flex flex-col gap-2">
        <div v-for="(val, index) in modelValue" :key="index" class="flex">
          <input
            :id="id"
            type="text"
            class="block w-full bg-white border p-1 focus:bg-white focus:border-gray-600 valid:border-green-400 appearance-none focus:outline-none"
            :class="{ rounded: !onRemove, 'rounded-l border-r-0': !!onRemove }"
            :value="val"
            @change="(e) => $emit('update:modelValue', index, e)"
            :disabled="disabled"
            :required="required"
          />
          <button
            type="button"
            @click="onRemove(index)"
            v-if="onRemove"
            class="border-gray-300 p-1 border rounded-r"
          >
            &times;
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
const emit = defineEmits(['update:modelValue'])

defineProps({
  label: String,
  modelValue: [String, Array],
  id: String,
  required: Boolean,
  disabled: Boolean,
  onRemove: Function,
})
</script>
